import PropTypes from 'prop-types';
import React from 'react';

import { catalogBibShape } from '@bibliocommons/bc-prop-types';

import {
  FullScreenOverlayBody,
  FullScreenOverlayContent,
  FullScreenOverlayHeader,
  FullScreenOverlayContainer
} from 'app/components/shared/FullScreenOverlay';
import { BibBrief as EnhancedBibBrief } from 'app/components/bibs/shared/BibBrief';

import AlternativeFormatBib from './AlternativeFormatBibContainer';

import './AlternativeFormatsOverlay.scss';

const AlternativeFormatsOverlay = ({ alerternativeFormatMetadataIds, catalogBib, closeOverlay, isOpen }) => {
  return (
    <FullScreenOverlayContainer
      dataKey="list-alternative-formats-overlay"
      handleClose={closeOverlay}
      open={isOpen}
      overlayKey="list-alternative-formats-overlay"
    >
      {catalogBib && (
        <FullScreenOverlayBody>
          <FullScreenOverlayHeader title="All Formats" />
          <FullScreenOverlayContent size="small">
            <div className="cp-alternative-formats-overlay">
              {catalogBib && (
                <div className="alternative-formats-overlay__bib-brief">
                  <EnhancedBibBrief catalogBib={catalogBib} />
                </div>
              )}
              <ul className="alternative-formats-overlay__list">
                {alerternativeFormatMetadataIds.map(alerternativeFormatMetadataId => {
                  return (
                    <li className="alternative-formats-overlay__item" key={alerternativeFormatMetadataId}>
                      <AlternativeFormatBib metadataId={alerternativeFormatMetadataId} />
                    </li>
                  );
                })}
              </ul>
            </div>
          </FullScreenOverlayContent>
        </FullScreenOverlayBody>
      )}
    </FullScreenOverlayContainer>
  );
};

AlternativeFormatsOverlay.propTypes = {
  alerternativeFormatMetadataIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  catalogBib: catalogBibShape,
  closeOverlay: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired
};

export default AlternativeFormatsOverlay;
